import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import * as serviceCallConfig from '../../../config/api_urls';
// import * as AdminDashboardActions from '../../../actions/admin/patients_actions';
import * as AdminDashboardActions from '../../../actions/admin/dashboard_actions';
import * as ReportActions from '../../../actions/report_actions';
import Header from '../../../components/header';
/*date picker*/
import DayPicker from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';

import 'react-day-picker/lib/style.css';

let screenIdentifier = 'dashboard';


let AdminDashboard = React.createClass({
    getInitialState() {
        return {
            dasboardData: null,
            isDeleting: false,
            selectedFromDay: null,
            selectedToDay: null, errorCsv: false, selectedFromDayDisplay: null,
            selectedToDayDisplay: null

        }
    },

    componentWillMount() {

    },
    componentWillReceiveProps(nextProps) {

        this.setState({ dasboardData: nextProps.AdminDashboardAData && nextProps.AdminDashboardAData.data });
    },
    componentDidMount() {

        let facilitiesID = this.props.UserDetails.selectdUserFacilityID;
        this.props.Dispatch(AdminDashboardActions.dashboardData(facilitiesID));
        // let clinicDate = new Date(this.props.UserDetails.facilitiCreatedDate);
        let getFromDate = new Date()
        // let clinicnewDate = clinicDate.getFullYear() + "-" + clinicDate.getMonth() + "-" + clinicDate.getDate();
        // this.setState({ selectedFromDay: clinicnewDate })
        this.setState({
            selectedFromDay: (((getFromDate.getMonth() > 8) ? (getFromDate.getMonth() + 1) :
                ('0' + (getFromDate.getMonth() + 1))) + '/' + ((getFromDate.getDate() > 9) ?
                    getFromDate.getDate() : ('0' + getFromDate.getDate())) + '/' + getFromDate.getFullYear())
        })
    },
    genrateAdmiCsvReport() {
        let selectedFromDate = new Date(this.state.selectedFromDay)
        let d = new Date();
        let data = "",
            facilityId = this.props.UserDetails.selectdUserFacilityID,
            reportType = this.refs.reportType.value, //1 or 2 1=staff 2= patient
            reportName = reportType === 1 ? "Staff-report-" : reportType === 2 ? "Patient-report-" : reportType === 3 ? 'RedFlag' : 'Survey-report-',
            // fromDate = this.state.selectedFromDay, //y-m-d
            fromDate = (selectedFromDate.getFullYear() + '-' + ((selectedFromDate.getMonth() > 8) ? (selectedFromDate.getMonth() + 1) :
                ('0' + (selectedFromDate.getMonth() + 1))) + '-' + ((selectedFromDate.getDate() > 9) ?
                    selectedFromDate.getDate() : ('0' + selectedFromDate.getDate()))),
            toDate = this.state.selectedToDay, //y-m-d,
            name = reportName + fromDate + " to " + toDate; //m-d-y
        data = facilityId + "/" + reportType + "/" + fromDate + "/" + toDate;
        if (facilityId && reportType.length && fromDate && toDate) {
            window.open(serviceCallConfig.BASE_URL + serviceCallConfig.CSV_REPORT_ADMIN + data);
            this.refs.reportType.value = '';
            // this.setState({ selectedFromDay: '' });
            let getFromDate = new Date()
            this.setState({ selectedFromDayDisplay: '' })
            this.setState({
                selectedFromDay: (((getFromDate.getMonth() > 8) ? (getFromDate.getMonth() + 1) :
                    ('0' + (getFromDate.getMonth() + 1))) + '/' + ((getFromDate.getDate() > 9) ?
                        getFromDate.getDate() : ('0' + getFromDate.getDate())) + '/' + getFromDate.getFullYear())
            })
            this.setState({ selectedToDay: '' });
        } else {
            this.setState({ errorCsv: true });
        }

    },
    handleFromDateChange(selectedDay, modifiers) {
        // debugger;
        let date = this.refs["from-date"].input.value.replace(/[^\w\s]/gi, '-');
        let ds = date.split('-');
        this.setState({ selectedFromDay: ds[2] + "-" + ds[0] + "-" + ds[1] });
        // this.setState({ selectedFromDayDisplay: ds[0] + "-" + ds[1] + "-" + ds[2] }); //yy-mm-dd
        let dateType = selectedDay._d
        console.log(date, dateType, selectedDay._d, 'date');
        this.setState({
            selectedFromDayDisplay: (((dateType.getMonth() > 8) ? (dateType.getMonth() + 1) :
                ('0' + (dateType.getMonth() + 1))) + '/' + ((dateType.getDate() > 9) ?
                    dateType.getDate() : ('0' + dateType.getDate())) + '/' + dateType.getFullYear())
        }); //YYYY-MM-DD

    },
    handleToDateChange(selectedDay, modifiers) {
        let date = this.refs["to-date"].input.value.replace(/[^\w\s]/gi, '-');
        let ds = date.split('-');
        this.setState({ selectedToDay: ds[2] + "-" + ds[0] + "-" + ds[1] });
        // this.setState({ selectedToDayDisplay: ds[0] + "-" + ds[1] + "-" + ds[2] });
        let dateType = selectedDay._d
        console.log(date, dateType, selectedDay._d, 'date');

        this.setState({
            selectedToDayDisplay: (((dateType.getMonth() > 8) ? (dateType.getMonth() + 1) :
                ('0' + (dateType.getMonth() + 1))) + '/' + ((dateType.getDate() > 9) ?
                    dateType.getDate() : ('0' + dateType.getDate())) + '/' + dateType.getFullYear())
        }); //YYYY-MM-DD
    },
    removeError() {
        this.setState({ errorCsv: false });
    },
    gotoRedflags() {
        this.props.router.push('/patients');
    },
    render() {
        let clinicDate = new Date(this.props.UserDetails.facilitiCreatedDate);
        let clinicnewDate = (((clinicDate.getMonth() > 8) ? (clinicDate.getMonth() + 1) :
            ('0' + (clinicDate.getMonth() + 1))) + '/' + ((clinicDate.getDate() > 9) ?
                clinicDate.getDate() : ('0' + clinicDate.getDate())) + '/' + clinicDate.getFullYear())
        // let clinicnewDate = clinicDate.getMonth()+1+"-"+clinicDate.getDate()+"-"+clinicDate.getFullYear();
        let formDate = this.state.selectedFromDay && this.state.selectedFromDayDisplay ? this.state.selectedFromDayDisplay : this.state.selectedFromDay ? this.state.selectedFromDay : clinicnewDate;
        // let formDate = this.state.selectedFromDay ? this.state.selectedFromDayDisplay : clinicnewDate;
        let toDate = this.state.selectedToDay ? this.state.selectedToDayDisplay : "";
        let redFlagCount = this.state.dasboardData ? this.state.dasboardData.totalFlags : 0;
        const startDayPickerProps = {
            disabledDays: {
                before: new Date(clinicnewDate),
                after: new Date(),
            },
            selectedDays: new Date(),

        };
        const endDayPickerProps = {
            disabledDays: {
                before: new Date(this.state.selectedFromDay),
                after: new Date(),
            }
        };
        return (
            <div>
                <header>
                    <Header screenIdentifier={screenIdentifier} />
                </header>
                <div className="dashboard-inner-content">
                    <div>

                    </div>
                    <div className="row">
                        <div className="col-xs-6 padding-left-none">
                            <div className="white-box summary">
                                <h3>Enrollment Summary</h3>
                                <div className="row">
                                    <div className="col-xs-6 no-padding">
                                        <h4>Total staff</h4>
                                        <div className="admin-dashboard-number">
                                            <p className="big-font same-line cyan">{this.state.dasboardData ? this.state.dasboardData.availableStaff : 0}</p>
                                            <p className="available same-line">AVAILABLE <br />{this.state.dasboardData ? this.state.dasboardData.totalStaff : 0}</p>
                                        </div>
                                        <h4>Total admins</h4>
                                        <div className="admin-dashboard-number">
                                            <p className="big-font purple same-line">{this.state.dasboardData ? this.state.dasboardData.availableAdmin : 0}</p>
                                            <p className="available same-line">AVAILABLE <br />{this.state.dasboardData ? this.state.dasboardData.totalAdmin : 0}</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 no-padding">
                                        <h4>Total Patients</h4>
                                        <div className="admin-dashboard-number">
                                            <p className="big-font orange same-line">{this.state.dasboardData ? this.state.dasboardData.availablePatients : 0}</p>
                                            <p className="available same-line">AVAILABLE <br />{this.state.dasboardData ? this.state.dasboardData.totalPatients : 0}</p>
                                        </div>
                                        <h4> Pending Enrollment</h4>
                                        <div className="admin-dashboard-number">
                                            <p className="big-font green">{this.state.dasboardData ? this.state.dasboardData.pendingEnrollments : 0}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-xs-6 padding-left-5 padding-right-none">
                            <div className="white-box generate">
                                <h3>REPORTS</h3>


                                <form className="Generate-form">
                                    <div className="row">

                                        <div className="col-xs-6 padding-left-none padding-right-none">
                                            <div className="aj-dropdown">
                                                <div className="source">
                                                    <div className="question-selection">
                                                        <select required="" ref="reportType" onFocus={this.removeError}>
                                                            <option value="" default="">Report Type</option>
                                                            <option value="2">Patient Report</option>
                                                            <option value="1">Staff Report</option>
                                                            <option value="3">Red Flag Report</option>
                                                            <option value="4">Survey Report</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                                <div className="generate-date">
                                    <div className="col-xs-6 padding-left-5 padding-right-none from-date" onFocus={this.removeError}>
                                        <span className="">Start date : </span>
                                        <DayPickerInput readOnly ref="from-date" onDayChange={this.handleFromDateChange} value={formDate} format="M/D/YYYY"
                                            dayPickerProps={startDayPickerProps} selected={clinicDate} placeholder="MM/DD/YYYY" />
                                    </div>

                                    <div className="col-xs-6 padding-left-5 padding-right-none to-date" onFocus={this.removeError}>
                                        <span className="from ">End date :  </span>
                                        <DayPickerInput readOnly ref="to-date" onDayChange={this.handleToDateChange} value={toDate}
                                            format="M/D/YYYY" dayPickerProps={endDayPickerProps} placeholder="MM/DD/YYYY" />
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                            <div className="buttonSubmit">
                                <button className="generateCsv" onClick={this.genrateAdmiCsvReport} >Generate Csv</button>
                            </div>
                            {this.state.errorCsv && <p className="error">Please enter necessary fields to proceed.</p>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6 padding-left-none">
                            <div className="white-box Survey">
                                <h3>Survey Completion</h3>
                                <div className="row">
                                    <div className="col-xs-6 no-padding">
                                        <h4>DAILY SURVEY</h4>
                                        <p className="very-big-font blue">{this.state.dasboardData ? this.state.dasboardData.dailySurvey : 0}
                                            <span className="small-font">%</span></p>
                                    </div>
                                    <div className="col-xs-6 no-paddingorange">
                                        <h4>WEEKLY SURVEY</h4>
                                        <p className="very-big-font orange">{this.state.dasboardData ? this.state.dasboardData.weeklySurvey : 0}
                                            <span className="small-font">%</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-6 padding-left-5 padding-right-none">
                            <div className="white-box red-flag">
                                <h3>RED FLAG</h3>
                                <div className="row">
                                    <div className="col-xs-6 no-padding">
                                        <h4>RED FLAG PATIENTS</h4>
                                        <p className="very-big-font red" onClick={this.gotoRedflags} > {redFlagCount}</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

let mapStateToProps = (state) => {
    return {
        UserDetails: state.User,
        AdminDashboardAData: state.AdminDashboard.AdminDashboardData,
    };
};

let mapDispatchToProps = (dispatch) => ({
    AdminDashboardActions: bindActionCreators(AdminDashboardActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(AdminDashboard));



/** WEBPACK FOOTER **
 ** ./src/components/admin/dashboard/dashboard.js
 **/